import { render, staticRenderFns } from "./KnowledgeCenter.vue?vue&type=template&id=3b4f9084"
import script from "./KnowledgeCenter.vue?vue&type=script&lang=js"
export * from "./KnowledgeCenter.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/all_messages.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports